import {
  DRUPAL_NODE_DISPLAY,
  type DrupalImage,
  type DrupalLink,
  type DrupalNode,
  type DrupalTerm,
} from '@commons/types/drupal';

import WebinarNodeCard from './Card';
import WebinarNodeFeatured from './Featured';
import WebinarNodeFeaturedTile from './FeaturedTile';
import WebinarNodeLabel from './Label';
import WebinarNodeSmallCard from './SmallCard';
import WebinarNodeTeaser from './Teaser';

/**
 * Type definition of a Webinar node properties.
 */

export type WebinarNodeProps = DrupalNode & {
  alias?: string;
  format: DrupalTerm;
  customDate: string;
  description: string;
  link?: DrupalLink;
  image?: DrupalImage;
  authors?: string;
  ctaLabel?: string;
  customLabel?: string;
  isGated?: boolean;
};

/**
 * Webinar node component.
 *
 * Renders a component based on the display type.
 */

export const WebinarNode = (props: WebinarNodeProps) => {
  switch (props.display) {
    default:
    case DRUPAL_NODE_DISPLAY.Default:
    case DRUPAL_NODE_DISPLAY.Label:
      return <WebinarNodeLabel {...props} />;
    case DRUPAL_NODE_DISPLAY.Teaser:
      return <WebinarNodeTeaser {...props} />;
    case DRUPAL_NODE_DISPLAY.Card:
      return <WebinarNodeCard {...props} />;
    case DRUPAL_NODE_DISPLAY.SmallCard:
      return <WebinarNodeSmallCard {...props} />;
    case DRUPAL_NODE_DISPLAY.Featured:
      return <WebinarNodeFeatured {...props} />;
    case DRUPAL_NODE_DISPLAY.FeaturedTile:
      return <WebinarNodeFeaturedTile {...props} />;
  }
};

export default WebinarNode;
